import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { DIPLOMAS } from '@/data/constants'
import { useChangeHighSchool } from '@/hooks/useChangeHighSchool'

const ChooseHighSchool = () => {
  const handleChangeHighSchool = useChangeHighSchool()

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="block w-full text-center font-bold text-sm h-14 cursor-pointer @max-[700px]:border-b @max-[700px]:border-warm-gray-600 @max-[700px]:border-dashed @min-[700px]:h-12 @min-[700px]:shadow-[0_2px_4px_0_rgba(0,0,0,0.1)] @min-[700px]:border @min-[700px]:border-warm-gray-600 @min-[700px]:rounded-md @min-[700px]:bg-white @min-[700px]:hover:bg-warm-gray-50">
          Velg en linje
        </button>
      </DialogTrigger>
      <DialogContent className="flex flex-col sm:max-w-[425px] max-h-[50vh]">
        <DialogHeader className="p-5 pb-3">
          <DialogTitle className="text-left">
            Legg til alle fag fra din linje
          </DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>
        <div className="overflow-y-auto p-5 pt-0">
          {DIPLOMAS.map((diploma) => (
            <div key={diploma.id}>
              <DialogClose asChild>
                <button
                  onClick={() => handleChangeHighSchool(diploma.id)}
                  className="w-full text-left cursor-pointer text-sm p-1 rounded-sm hover:bg-purple-100"
                >
                  {diploma.name}
                </button>
              </DialogClose>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ChooseHighSchool
